import {useMutation} from "@tanstack/react-query";
import {cancelExpedientMutationOptions} from "./cancel-expedient.mutation-options";

export function useCancelExpedient() {
  return useMutation(cancelExpedientMutationOptions());
}
